import React, { FunctionComponent } from "react";
import { Breadcrumb } from "antd";
import { useLocation, Link } from "react-router-dom";
import "./AppBreadcrumb.css";
import { ConfigurationDisplayDto } from "../../../services/ApiTypes.ts";

interface MyBreadcrumbProps {
  toolbar?: React.ReactNode;
  configurationDisplays: ConfigurationDisplayDto[];
}

interface BreadcrumbItem {
  label: JSX.Element;
    key: string;
}

const MyBreadcrumb: FunctionComponent<MyBreadcrumbProps> = ({ configurationDisplays, toolbar }) => {
  const location = useLocation();
  const pathSnippets = location.pathname.split("/").filter((i) => i);
  const items: BreadcrumbItem[] = [];

  pathSnippets.forEach((segment, index) => {
    const url = `/${pathSnippets.slice(0, index + 1).join("/")}`;

    if (index === 0 && segment === "configuration") {
      items.push({
        label: (
          <Link to="/">
            Configurations
          </Link>
        ),
        key: url,
      });
    } else if (index === 1 && pathSnippets[0] === "configuration") {
      const configuration = configurationDisplays.find(
        (config) => config.id === segment
      );
      if (configuration) {
        items.push({
          label: (
            <Link to={`/configuration/${configuration.id}`}>
              {configuration.displayName}
            </Link>
          ),
          key: url,
        });
      }
    } else if (segment === "users") {
      items.push({
        label: (
          <Link to={url}>
            Users
          </Link>
        ),
        key: url,
      });
    }
  });

  return (
    <div className="breadcrumbContainer">
      <Breadcrumb className="breadcrumb" separator=">">
        {items.map((item) => (
          <Breadcrumb.Item key={item.key}>{item.label}</Breadcrumb.Item>
        ))}
      </Breadcrumb>
      {toolbar && <div className="toolbar">{toolbar}</div>}
    </div>
  );
};

export default MyBreadcrumb;
